import {ShapeComponent, shapeComponent} from "set-state-compare/build/shape-component"
import FrontLayout from "components/front-layout"
import memo from "set-state-compare/build/memo"
import PageContentsPresentation from "components/page-contents/presentation"
import React from "react"
import useI18n from "i18n-on-steroids/build/src/use-i18n.js"
/** @typedef {object} LayoutNotFoundPageProps */

/** @typedef {object} LayoutNotFoundPageState */

/**
 * @extends {ShapeComponent<LayoutNotFoundPageProps, LayoutNotFoundPageState>}
 */
class LayoutNotFoundPage extends ShapeComponent {
  setup() {
    const {t} = useI18n({namespace: "js.components.layout.not_found_page"})

    this.t = t
  }

  render() {
    return (
      <FrontLayout className="components--layout--not-found-page">
        <PageContentsPresentation identifier="layout/not-found-page" />
      </FrontLayout>
    )
  }
}

export default memo(shapeComponent(LayoutNotFoundPage))
